module.exports = __webpack_public_path__ + "img/arrow-right-20x20.776d46c5.svg";